import {
  Select,
  ListBox,
  ListBoxItem,
  Popover,
  SelectValue,
  Button as AriaButton,
} from 'react-aria-components';

import { eachDayOfInterval, format, subMonths, addMonths } from 'date-fns';

type Props = {
  selectedDate: string;
  setSelectedDate: (date: string) => void;
};

const DateSelect = ({ selectedDate, setSelectedDate }: Props) => {
  const getDates = () => {
    const dateRange = eachDayOfInterval({
      start: subMonths(new Date(), 1),
      end: addMonths(new Date(), 1),
    });

    return dateRange.map((date) => ({
      value: format(date, 'yyyy-MM-dd'),
      label: format(date, 'yyyy年MM月dd日'),
    }));
  };
  return (
    <div className="flex flex-row gap-4">
      <Select
        id="select"
        // selectedKey={value}
        onSelectionChange={(selected) => {
          if (typeof selected === 'string') {
            setSelectedDate(selected);
          }
        }}
        defaultSelectedKey={format(new Date(), 'yyyy-MM-dd')}
      >
        <AriaButton className="mb-2 flex h-14 w-full flex-row items-center justify-between rounded-md border border-gray-900 bg-white px-3 py-2 text-left text-sm focus:border-2 focus:border-yellow-700 focus:outline-none focus:ring-1 focus:ring-blue-500">
          <SelectValue className="block truncate">
            {selectedDate
              ? getDates().find((date) => date.value === selectedDate)?.label
              : '日付を選択'}
          </SelectValue>
          <span className="pointer-events-none ml-2">▼</span>
        </AriaButton>
        <Popover
          shouldFlip={true}
          placement="bottom start"
          className="w-full md:w-auto"
        >
          <ListBox className="max-h-60 w-full overflow-auto rounded-md border border-gray-300 bg-white py-1 text-sm shadow-lg">
            {getDates().map((date, index) => (
              <ListBoxItem
                id={date.value}
                key={index}
                textValue={date.value}
                className={({ isFocused, isSelected }) =>
                  `relative cursor-pointer select-none px-4 py-2 ${isFocused ? 'bg-blue-100' : ''} ${isSelected ? 'bg-blue-500 text-white' : ''} ${!isSelected && !isFocused ? 'text-gray-900' : ''} `
                }
              >
                {date.label}
              </ListBoxItem>
            ))}
          </ListBox>
        </Popover>
      </Select>
    </div>
  );
};

export default DateSelect;
